import { timeFormat } from '@/utils/other';
import BaseListClass from './BaseListClass';
import ListClass from './ListClass';
import RequestApi from './RequestApiClass';

type IGetIssues = IIssue.IRequest.IGetIssues;
type IIssueInfo = IIssue.IResponse.IIssueInfo;

interface IGetIssueParams {
  pageindex: number;
  pagesize: number;
}

const defaultParams: IGetIssueParams = {
  pageindex: 1,
  pagesize: 100,
};

export default class IssueListClass extends BaseListClass<IIssueInfo> {
  public $requestParams: IGetIssues = { ...defaultParams };
  public detailParams: IGetIssues = {
    returnComment: true,
  };
  constructor() {
    super({
      list: new ListClass<IIssueInfo>(),
      requestApi: new RequestApi('Issue'),
    });
  }
  public initRequestParams() {
    this.$requestParams = { ...defaultParams };
  }
  public convertData(issues: IIssueInfo[]): IIssueInfo[] {
    return issues.map((issue) => ({
      ...issue,
      createdOn: timeFormat(issue.createdOn),
    }));
  }
  public checkItem(issue: IIssueInfo) {
    const result: boolean[] = [];
    if (this.$requestParams.keyword) {
      result.push(issue.title.includes(this.$requestParams.keyword));
    }
    if (this.$requestParams.id) {
      result.push(issue.id === this.$requestParams.id);
    }
    if (this.$requestParams.status) {
      result.push(issue.status === this.$requestParams.status);
    }
    return result.every((value) => value);
  }
}

export const issueListInstance = new IssueListClass();
